export default __webpack_public_path__ + "static/media/location-white.949eeda4.svg";